import { createContext, useContext } from "react";

export enum ToggleSource {
  RouteHandler,
  UserInteraction,
}

export interface NavBarContextValue {
  expanded: boolean;
  hasUserManuallyToggled: boolean;
  toggleExpanded: (source: ToggleSource, isOpened?: boolean) => void;
}

const NavBarContext = createContext<NavBarContextValue>({
  expanded: false,
  hasUserManuallyToggled: false,
  toggleExpanded: () => undefined,
});

export const {
  Consumer: NavBarContextConsumer,
  Provider: NavBarContextProvider,
} = NavBarContext;

export const useNavBarContext = () => useContext(NavBarContext);
